import { Col, Row } from 'antd';
import classes from './wrapper.module.scss';
import { ISlide, Slider } from './slider/slider.component';
import { useTranslation } from 'react-i18next';
import illustrationPath from '../../assets/imgs/Artboard1.png';
import illustrationPath1 from '../../assets/imgs/Artboard2.png';
import illustrationPath2 from '../../assets/imgs/Artboard3.png';

interface IProps {
  children?: JSX.Element;
}

export const Wrapper = (props: IProps) => {
  const { t } = useTranslation();
  const form = props.children;
  const sliderSlides: ISlide[] = [
    {
      image: { path: illustrationPath, alt: 'slide-1' },
      title: t('slider.meet-title'),
      subtitle: t('slider.meet-description')
    },
    {
      image: { path: illustrationPath1, alt: 'slide-2' },
      title: t('slider.customize-title'),
      subtitle: t('slider.customize-description')
    },
    {
      image: { path: illustrationPath2, alt: 'slide-3' },
      title: t('slider.connect-title'),
      subtitle: t('slider.connect-description')
    }
  ];

  return (
    <Row justify="space-between" style={{ height: '100vh' }}>
      <Col prefixCls={classes.formWrapper}>{form}</Col>
      <Col prefixCls={classes.illustrationWrapper}>
        <Slider slides={sliderSlides} intervalMs={3000} />
      </Col>
    </Row>
  );
};
